import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgRefah = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#004B7F'
      d='M5.516 2.009c2.44-.023 4.88 0 7.32-.011a.9.9 0 0 1 .455.12.9.9 0 0 0 .19.416c.646.9 1.06 1.94 1.41 2.988.613 2.417.278 5.13-1.122 7.213-.164.25-.304.63-.652.637-2.252-.016-4.503.008-6.754-.012.312-.176.679-.22.994-.393 1.002-.5 1.88-1.328 2.344-2.373.473-.84.622-1.821.7-2.773a4.05 4.05 0 0 0-.27-1.7c-.329-.771-.722-1.529-1.278-2.158-.879-.988-2.09-1.605-3.337-1.957zM2.033 5.1c1.643 0 3.288.04 4.93-.027.792.016 1.584-.048 2.376-.005-.3.193-.642.29-.957.447-1.332.675-2.564 1.693-3.2 3.092-.93 2.01-.449 4.614 1.201 6.086.37.433.82.789 1.325 1.046 2.862.024 5.727 0 8.59.01l-.033-.237.059.269c.99-.6 1.884-1.41 2.435-2.453.648-1.163.772-2.585.423-3.865-.412-1.605-1.569-2.927-2.964-3.74-.358-.2-.71-.434-1.116-.525l-.137-.143c1.527 0 3.058.041 4.585-.024.816.013 1.632-.049 2.45-.022.457.586.785 1.254 1.166 1.89q.053.222.162.421c.393 1.027.62 2.112.671 3.213.017 1.672-.385 3.364-1.236 4.801-.046.127-.245.27-.05.386-.363.043-.488.482-.681.746-.385.058-.773.03-1.16.034H2.33C.817 14.777-.096 12.459.012 10.132c.032-1.15.406-2.26.909-3.278.318-.617.662-1.23 1.115-1.756zm7.516 13.3a2.93 2.93 0 0 1 1.092-.99c.44-.229.931-.34 1.426-.323.378-.005.737.127 1.1.216.507.297.992.66 1.284 1.19.39.645.523 1.418.368 2.159-.034.17-.095.343-.045.518-.25.161-.32.482-.508.696-.509.638-1.264 1.135-2.095 1.118a2.7 2.7 0 0 1-1.144-.143 2.8 2.8 0 0 1-.99-.604c-1.083-.908-1.254-2.67-.484-3.84'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgRefah)
export default ForwardRef
